import { render, staticRenderFns } from "./AguardandoPagamentoComponent.vue?vue&type=template&id=2818096e&scoped=true"
import script from "./AguardandoPagamentoComponent.vue?vue&type=script&lang=js"
export * from "./AguardandoPagamentoComponent.vue?vue&type=script&lang=js"
import style0 from "./AguardandoPagamentoComponent.vue?vue&type=style&index=0&id=2818096e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2818096e",
  null
  
)

export default component.exports